import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=26f5e0aa&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=26f5e0aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f5e0aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f5e0aa')) {
      api.createRecord('26f5e0aa', component.options)
    } else {
      api.reload('26f5e0aa', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=26f5e0aa&scoped=true&", function () {
      api.rerender('26f5e0aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z9AB1gbL4Rz7/JS/comp/GuestBox.vue"
export default component.exports